/*eslint-disable */
import React, { useEffect, useState } from 'react';
import { isValidImage, isValidUrl, shouldShowBanner } from '../../../utils/helpers';
import { Counter, Informative, Redirection } from './Cyber';
import { CAMPAIGN_TYPE, validSubtypesRedirect } from '../../../constants/contentstack';
import './styles.scss';

const renderCyber = (subtype, props) => {
  const {
    text: { main },
    banner_with_redirection,
    image_png,
    image_webp,
    time: { start_date, final_date },
    active_counter,
    reset_days,
  } = props;
  const { active_go_icon_button, url } = banner_with_redirection;
  const cleanMainText = main?.trim();
  const validMainText = !!cleanMainText;

  switch (subtype) {
    case 'cyber_informative':
      if (validMainText && isValidImage(image_png) && isValidImage(image_webp))
        return <Informative text={cleanMainText} imagePng={image_png} imageWebp={image_webp} />;
      break;
    case 'cyber_redirection':
      if (validMainText && active_go_icon_button && isValidImage(image_png) && isValidImage(image_webp) && isValidUrl(url))
        return <Redirection text={cleanMainText} imagePng={image_png} imageWebp={image_webp} activeBtnGo={active_go_icon_button} />;
      break;
    case 'cyber_counter':
      if (validMainText && isValidImage(image_png) && isValidImage(image_webp) && active_counter && start_date && final_date)
        return (
          <Counter
            text={cleanMainText}
            imagePng={image_png}
            imageWebp={image_webp}
            activeCounter={active_counter}
            startDate={start_date}
            finalDate={final_date}
            resetDays={reset_days}
          />
        );
      break;
    default:
      return null;
  }
};

export const BannerCampaign = ({ dynamicContent, nameCampaign }) => {
  const content =
    dynamicContent?.find(
      ({ venta_digital_cintillo }) => venta_digital_cintillo?.type === CAMPAIGN_TYPE.cyber && shouldShowBanner(venta_digital_cintillo.time),
    )?.venta_digital_cintillo ||
    dynamicContent?.find(
      ({ venta_digital_cintillo }) => venta_digital_cintillo?.type === CAMPAIGN_TYPE.promotional && shouldShowBanner(venta_digital_cintillo.time),
    )?.venta_digital_cintillo ||
    {};

  const { time, subtype } = content;
  const hasRedirection = validSubtypesRedirect.includes(subtype);
  const validateBanner = shouldShowBanner(time);

  const [showBanner, setShowBanner] = useState(validateBanner);

  useEffect(() => {
    setShowBanner(validateBanner);
  }, [validateBanner]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const header = document.querySelector('header');

    const setHeaderMargin = () => {
      const banner = document.querySelector('.banner-promotional') || document.querySelector('.banner-cyberI');
      if (banner && header) {
        const bannerHeight = banner?.offsetHeight || 0;
        header.style.marginTop = `${bannerHeight}px`;
      }
    };

    const clearHeaderMargin = () => {
      if (header) header.style.marginTop = '';
    };

    if (showBanner) setHeaderMargin();
    else clearHeaderMargin();

    const observer = new MutationObserver(() => {
      if (showBanner) setHeaderMargin();
      else clearHeaderMargin();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [showBanner]);

  const handleClick = (content) => {
    if (content?.banner_with_redirection?.active_go_icon_button && isValidUrl(content?.banner_with_redirection?.url)) {
      window.open(content?.banner_with_redirection?.url || '', '_blank');
    }
  };

  const renderBanner = (className, component) =>
    component && showBanner ? (
      <div
        className={className}
        onClick={() => {
          if (hasRedirection) {
            handleClick(content);
          }
        }}
        style={
          content?.banner_with_redirection?.active_go_icon_button && isValidUrl(content?.banner_with_redirection?.url) && hasRedirection
            ? { cursor: 'pointer' }
            : undefined
        }
      >
        {component}
      </div>
    ) : null;

  if (content?.type === 'cyber') {
    return renderBanner('banner-cyberI', renderCyber(content?.subtype || '', content));
  }

  return null;
};
